const getApplications = (state) => {
  return state.applications
}


export default {
  getApplications,
}
